<div class="sticky top-0 z-20 flex flex-wrap items-center justify-start border-b bg-white px-5">
  <ng-content></ng-content>
</div>
